export default "__VITE_ASSET__DSNuhGua__"